export const choices = {
  EMPTY: "",
  QAL2_AST: "QAL2_AST",
  OUT_OF_REGULATION: "OUT_OF_REGULATION",
  REGULATORY: "REGULATORY",
  UNANNOUNCED: "UNANNOUNCED",
  NONE: "NONE",
  ALL: "ALL",
};
